import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

function MakineAylikPayChart({ selectedMonthData }) {
  const chartData = useMemo(() => {
    if (!selectedMonthData?.ayToplam) return null;

    const labels = selectedMonthData.ayToplam.map(
      (m) => `Makine ${m.makinaAdi}`
    );
    const data = selectedMonthData.ayToplam.map((m) => m.toplamSure);

    const toplam = data.reduce((a, b) => a + b, 0);
    const yuzdeler = data.map((v) => ((v / toplam) * 100).toFixed(1));

    return {
      labels: labels.map((l, i) => `${l} (%${yuzdeler[i]})`),
      datasets: [
        {
          label: "Toplam Çalışma Süresi (dk)",
          data,
          backgroundColor: ["#0d6efd", "#20c997", "#ffc107", "#dc3545"],
          borderWidth: 1,
        },
      ],
    };
  }, [selectedMonthData]);

  const options = {
    plugins: {
      title: {
        display: true,
        text: `${selectedMonthData?.ay} Ayı Makine Pay Dağılımı`,
        font: { size: 18, weight: "bold" },
      },
      legend: { position: "right" },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const label = ctx.label || "";
            const value = ctx.parsed;
            return `${label}: ${value.toLocaleString()} dk`;
          },
        },
      },
    },
  };

  return (
    <div
      className="p-4 bg-white rounded shadow-sm mt-4"
      style={{ maxWidth: "500px", margin: "0 auto" }}
    >
      {chartData ? (
        <Doughnut data={chartData} options={options} />
      ) : (
        <p className="text-muted text-center">Veri bulunamadı</p>
      )}
    </div>
  );
}

export default MakineAylikPayChart;
